var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configLoading
    ? _c(
        "div",
        { attrs: { id: "appCentral" } },
        [
          _c("vue-progress-bar"),
          _vm.loader.status
            ? _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loader.status,
                    expression: "loader.status"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading.fullscreen.lock",
                    value: true,
                    expression: "true",
                    modifiers: { fullscreen: true, lock: true }
                  }
                ],
                attrs: { "element-loading-text": _vm.loader.text }
              })
            : _vm._e(),
          _c(
            "header",
            [
              _c("main-header", {
                attrs: { notificacao: false, hasListagemModelo: false }
              })
            ],
            1
          ),
          _c(
            "main",
            { staticClass: "container" },
            [
              !_vm.$route.meta.hideSideMenu
                ? _c("side-menu", { staticClass: "side-menu" })
                : _vm._e(),
              _c("div", { staticClass: "content" }, [_c("router-view")], 1)
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e06d2e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e06d2e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/MainPage.vue
// module id = null
// module chunks = 